<ion-header>
  <ion-toolbar>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col (click)="goToHome()">
          <div class="logo"></div>
        </ion-col>
        @for (product of productList; track product.productName; let i = $index) {
          <ion-col (click)="openMegamenu(i)">
            <ion-text [ngClass]="{'selected-product': menuNavigationService.selectedProductFromMegaMenu === i}" [innerHTML]="product?.productName"></ion-text>
            @if (selectedProductIndex !== i) {
              <ion-icon name="chevron-down-outline"></ion-icon>
            } @else if (selectedProductIndex === i) {
              <ion-icon name="chevron-up-outline"></ion-icon>
            }
          </ion-col>
        }
        @if (isExternal) {
          <ion-col (click)="openTermsAndPrivacy('terms')">
            <ion-text [ngClass]="{'selected-product': selectedItem === 'terms'}">{{ 'TERMS_AND_CONDITIONS' | translate }}</ion-text>
          </ion-col>
          <ion-col (click)="openTermsAndPrivacy('privacy')">
            <ion-text [ngClass]="{'selected-product': selectedItem === 'privacy'}">{{ 'PRIVACY_POLICY' | translate }}</ion-text>
          </ion-col>
        }
        <ion-col>
          <app-select-theme fromPage="header-desktop"></app-select-theme>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-header>

@if (selectedProductIndex !== -1) {
  <app-mega-menu [selectedProductIndex]="selectedProductIndex" (closeMegamenu)="closeMegamenu($event)"></app-mega-menu>
}
